import axios from "axios";
import { appConstants } from "./appConstants";
import { loadingAction } from "ReduxReducers/loadingReducer";
import { IdleAction } from "ReduxReducers/tokenGenerateTime";
import { generateToken } from "./generic";
import { captureWebsiteDocument, downloadWebsiteDocument } from "./documentPdf";

let axiosConfig = {
  headers: {
    Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}`,
  },
};
let id;
if (JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")) !== null) {
  id = JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))._id;
}

const saveBillingDocument = async (
  action,
  values,
  callBack,
  dispatch,
  errorCallBack,
  { showLoader = true } = {}
) => {
  if (showLoader) dispatch(loadingAction(true));
  try {
    const response = await axios.post(
      appConstants.baseURL + `invoice/${action}`,
      values,
      {
        headers: { Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}` },
        timeout: action === "updateRCTI" && values.sendEmailFlag ? 60000 : 30000,
      }
    );
    await callBack(response.data);
    dispatch(IdleAction(new Date()));
    return response.data;
  } catch (error) {
    if (error?.response?.data?.Result_Message === "TokenExpiredError")
      generateToken(id, dispatch);
    const failure = {
      Result_Status: false,
      Result_Message:
        error?.response?.data?.Result_Message ||
        error?.response?.data?.message ||
        (error.code === "ECONNABORTED"
          ? "Saving took too long. Check the document list before trying again."
          : "The draft could not be saved. Please try again."),
      Result_Output: error?.response?.data?.Result_Output,
    };
    await (typeof errorCallBack === "function"
      ? errorCallBack(failure)
      : callBack(failure));
    return failure;
  } finally {
    if (showLoader) dispatch(loadingAction(false));
  }
};

export const SaveInvoice = (values, callBack, dispatch, options) =>
  saveBillingDocument("addInvoice", values, callBack, dispatch, null, options);

export const getQuotationsForInvoice = async (values, callBack, dispatch) => {
  // dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoice/fetchQuotationData",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      // dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      // dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getQuotationsForInvoice===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const fetchInvoiceData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "invoice/fetchInvoices", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log(
        "error fetchInvoiceData===>",
        error?.response?.data?.Result_Message
      );
    });
};
export const PreviewInvoiceDetails = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoice/previewInvoiceDetails",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log(
        "error PreviewInvoiceDetails===>",
        error?.response?.data?.Result_Message
      );
    });
};
export const getItemsForInvoice = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  return axios
    .post(
      appConstants.baseURL + "invoice/fetchItemsForInvoice",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getItemsForInvoice===>",
        error?.response?.data?.Result_Message
      );
    })
    .finally(() => {
      dispatch(loadingAction(false));
    });
};
export const getInvoiceDetailsByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoice/fetchInvoiceDetailsByID",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") {
        generateToken(id, dispatch);
      }

      console.log(
        "error getInvoiceDetailsByID===>",
        error?.response?.data?.Result_Message
      );
    });
};
export const UpdateInvoice = (values, callBack, dispatch, options) =>
  saveBillingDocument(
    "updateInvoice",
    values,
    callBack,
    dispatch,
    null,
    options
  );

export const deleteforInvoice = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "invoice/deleteInvoice", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      // dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      // dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error deleteInvoice===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const ResendEmail = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  try {
    const documentSnapshot = await captureWebsiteDocument("invoice", values.selectedID);
    const res = await axios.post(
      appConstants.baseURL + "invoice/resendEmail",
      { ...values, documentSnapshot },
      axiosConfig
    );
    await callBack(res.data);
    dispatch(IdleAction(new Date()));
  } catch (error) {
    const response = error?.response?.data;
    const message =
      response?.Result_Message ||
      response?.message ||
      error?.message ||
      "Failed to send invoice email.";
    if (message === "TokenExpiredError") await generateToken(id, dispatch);
    await callBack({
      Result_Status: false,
      Result_Message: message,
      Result_Output: [],
    });
    console.log("Error while Resend Email: ", message);
  } finally {
    dispatch(loadingAction(false));
  }
};

//RCTI

export const getSupplierForRCTI = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  return axios
    .post(
      appConstants.baseURL + "invoice/fetchSupplierForRCTI",
      { ...values, includeUnavailableContacts: true },
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getSupplierForRCTI===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const SaveRCTI = (values, callBack, dispatch, errorCallBack, options) =>
  saveBillingDocument(
    "addRCTI",
    values,
    callBack,
    dispatch,
    errorCallBack,
    options
  );

export const UpdateRCTI = (
  values,
  callBack,
  dispatch,
  errorCallBack,
  options
) =>
  saveBillingDocument(
    "updateRCTI",
    values,
    callBack,
    dispatch,
    errorCallBack,
    options
  );

export const getRCTIDetailsByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  return axios
    .post(
      appConstants.baseURL + "invoice/fetchRCTIDetailsByID",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getRCTIDetailsByID===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const getRCTI = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "invoice/fetchRCTI", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error getRCTI===>", error?.response?.data?.Result_Message);
    });
};
export const deleteSelectedRCTI = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "invoice/deleteRCTI", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error deleteSelectedRCTI===>",
        error?.response?.data?.Result_Message
      );
    });
};
export const getRCTIByID = async (
  values,
  callBack,
  dispatch,
  errorCallBack
) => {
  dispatch(loadingAction(true));
  return axios
    .post(appConstants.baseURL + "invoice/viewRCTIByID", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
      return res.data;
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getRCTIByID===>",
        error?.response?.data?.Result_Message
      );
      if (typeof errorCallBack === "function")
        errorCallBack(
          error?.response?.data || {
            Result_Message:
              "RCTI details could not be loaded. Check your connection and retry.",
          }
        );
      return null;
    });
};

export const resendEmailRcti = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  return axios
    .post(appConstants.baseURL + "invoice/resendEmailRcti", values, { headers: { Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}` }, timeout: 60000 })
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);

      callBack({ Result_Status: false, Result_Message: error?.response?.data?.Result_Message || "RCTI email could not be sent. Please retry.", Result_Output: [] });
    });
};

export const getFetchCustomerInvoiceBillDetails = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoice/FetchCustomerInvoiceBillDetails",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") {
        generateToken(id, dispatch);
      }

      console.log(
        "error getFetchCustomerInvoiceBillDetails===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const getDefaultInvoiceDueDate = async (values, callBack, dispatch) => {
  // dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoice/fetchDefaultInvoiceDueDate",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      // dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      // dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") {
        generateToken(id, dispatch);
      }

      console.log(
        "error getDefaultInvoiceDueDate===>",
        error?.response?.data?.Result_Message
      );
    });
};
export const getDefaultRCTIDueDate = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoice/fetchDefaultRCTIDueDate",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") {
        generateToken(id, dispatch);
      }

      console.log(
        "error getDefaultRCTIDueDate===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const submitInvoicePayment = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  await axios
    .post(
      appConstants.baseURL + "invoice/submitInvoicePaymentDetails",
      values,
      axiosConfig
    )
    .then((res) => {
      dispatch(loadingAction(false));
      callBack(res.data);
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      console.log("submitInvoicePayment:", error);
      if (error?.response?.data?.Result_Message === "TokenExpiredError") {
        generateToken(id, dispatch);
      }
    });
};

export const getCutomerInvoiceStatement = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  await axios
    .post(
      appConstants.baseURL + "invoice/fetchCutomerInvoiceStatement",
      values,
      axiosConfig
    )
    .then((res) => {
      dispatch(loadingAction(false));
      callBack(res.data);
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      console.log("fetchCutomerInvoiceStatement:", error);
      if (error?.response?.data?.Result_Message === "TokenExpiredError") {
        generateToken(id, dispatch);
      }
    });
};

export const downloadRCTI = async (values, callback, dispatch) => {
  return downloadWebsiteDocument("rcti", values, callback, dispatch);
};
export const PreviewRCTIDetails = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoice/previewRCTIDetails",
      values,
      axiosConfig
    )
    .then((res) => {
      console.log("sss", res);
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log(
        "error previewRCTIDetails===>",
        error?.response?.data?.Result_Message
      );
    });
};

// Credit Functionalities

export const SaveCredit = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  return axios
    .post(appConstants.baseURL + "credit/addCredit", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      callBack({Result_Status:false,Result_Message:error?.response?.data?.Result_Message || "Credit note could not be saved. Please retry."});
    });
};

export const UpdateCredit = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  return axios
    .post(appConstants.baseURL + "credit/updateCredit", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);

      callBack({Result_Status:false,Result_Message:error?.response?.data?.Result_Message || "Credit note could not be updated. Please retry."});
    });
};

export const getCreditDetailsByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "credit/fetchCreditDetailsByID",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") {
        generateToken(id, dispatch);
      }

      console.log(
        "error fetchCreditDetailsByID===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const ResendEmailCredit = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "credit/resendEmailCredit",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);

      console.log(
        "Error while resendEmailCredit: ",
        error?.response?.data?.Result_Message
      );
    });
};

export const PreviewCreditDetails = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "credit/previewCreditDetails",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log(
        "error previewCreditDetails===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const downloadCredit = async (values, callback, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoicePdfFormat/downloadCredit",
      values,
      axiosConfig
    )
    .then((res) => {
      callback(res);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error downloadInvoice===>",
        error?.response?.data?.Result_Message
      );
      console.log(error);
    });
};
